<div
  class="youtube-video-container"
  [attr.id]="'video-' + videoId + sufixId"
  (click)="loadVideo()"
>
  <img class="youtube-thumb" [alt]="title" [src]="videoImage" loading="lazy" />
  <div class="youtube-play-button">
    <i class="pi pi-youtube"></i>
  </div>
</div>
